"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const deserializer_1 = require("./deserializer");
const serializer_1 = require("./serializer");
function toJSON(xdr) {
    return serializer_1.default(xdr.constructor, xdr);
}
exports.toJSON = toJSON;
function toXDR(typeDefinition, payload) {
    return deserializer_1.default(typeDefinition, payload);
}
exports.toXDR = toXDR;
//# sourceMappingURL=index.js.map